import { Component, Inject, Input, OnInit, PLATFORM_ID , ViewChild , ElementRef, ChangeDetectorRef } from "@angular/core";
import { NavService, Menu } from "../../services/nav.service";
import { Router } from "@angular/router";
import { CategoriesService } from "./../../services/categories";
import { CommonService } from "../../../shared/services/common.service";
import { UserService } from "../../../shared/services/user.service";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { menuSlider , CategorySlider, HomeSlider } from "../../data/slider";
// Add the correct import for owlCarouselComponent below, adjust the path as needed:
import { CarouselComponent } from 'ngx-owl-carousel-o';

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
  
  @ViewChild('categoriesContainer') categoriesContainer!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent ;

  @Input('categoryResponse') public categoryResponse: any;
  
  public menuItems: any[] = [];
  public categories: any[] = [];
  public children: any[] = [];
  public childrenchildren: any[] = [];
  public menuSliderConfig = {
    ... menuSlider,
    mouseDrag: false,    // 👈 disables mouse drag
    touchDrag: false,    // 👈 disables touch swipe
    pullDrag: false,     // 👈 disables pull resistance

  };
  tradmarkschildren: any[];
  allTradmarks: any = [];
  currentTadmarksArr: any = [];
  subservicechildren: any;
  currentSubArr: any;
  targetElement!:HTMLElement;
  sliderIndex = 0;
  constructor(
    private router: Router,
    public user: UserService,
    public navServices: NavService,
    public Commen: CommonService,
    private categoryService: CategoriesService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.navServices.items.subscribe(
      (menuItems) => (this.menuItems = menuItems)
    );
    this.router.events.subscribe((event) => {
      this.navServices.mainMenuToggle = false;
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.getMainCategories(this.categoryResponse);
    }
  }

  ngAfterViewInit(): void {
  }

  getMainCategories(data) {
    // var obj0: Menu = {
    //   path: "",
    //   title:
    //     localStorage.getItem("front-lang") == "en" ? "home" : "الصفحة الرئيسية",
    //   type: "link",
    // };
    // var obj3: Menu = {
    //   path: "/elements/trademarks",
    //   title:
    //     localStorage.getItem("front-lang") == "en"
    //       ? "Brands"
    //       : "العلامات التجارية",
    //   type: "link",
    // };
    // var obj2: Menu = {
    //   path:
    //     "/trademarks/"+ localStorage.getItem("front-lang") == "en" 
    //       ? "about-us"
    //       : "من-نحن",
    //   title: localStorage.getItem("front-lang") == "en" ? "about us" : "من نحن",
    //   type: "link",
    // };

    this.menuItems = [];
    // this.menuItems.push(obj0);
    // this.menuItems.push(obj3);
    // this.menuItems.push(obj2);
    // 
    if (data) {
      this.categories = data.data;
      this.children = [];

      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].haveSubService == false) {
          let child: any = {
            path:
              "/shop/category/" +
              this.categories[i].id +
              "/" +
              this.categories[i].ser_name,
            title: this.categories[i].ser_name,
            id: this.categories[i].id,
            type: "link",
          };
          this.children.push(child);
          this.menuItems.push(child); 

        } else {
          
          var child2: any = {
            title: this.categories[i].ser_name,
            type: "link",
            active: false,
            id: this.categories[i].id,
            path:
              "/shop/category/" +
              this.categories[i].id +
              "/" +
              this.categories[i].ser_name?.split(" ").join("-"),
            children: this.childrenchildren,
          };
          
          this.menuItems.push(child2); 
        }
        this.tradmarkschildren = [];
        let tradArr = []
        for (let ij = 0; ij < this.categories[i].famous_trade_marks.length; ij++) {
          let tradmarkCat: any = {
            path:
              "/shop/trademarkes/" +
              this.categories[i].famous_trade_marks[ij].id +
              "/" +
              this.categories[i].famous_trade_marks[ij].title
                ?.split(" ")
                .join("-"),
            title: this.categories[i].famous_trade_marks[ij].title,
            type: "link",
            image: this.categories[i].famous_trade_marks[ij].image,
            id: this.categories[i].famous_trade_marks[ij].id,
            
          };
          tradArr.push(tradmarkCat);
          
        }
        this.allTradmarks.push({catId : this.categories[i].id,tradArr:tradArr});

        let serviceArr = []
        for (let ij = 0; ij < this.categories[i].subServices.length; ij++) {
          let childchild: any = {
            path:
              "/shop/category/" +
              this.categories[i].subServices[ij].id +
              "/" +
              this.categories[i].subServices[ij].ser_name
                ?.split(" ")
                .join("-"),
            title: this.categories[i].subServices[ij].ser_name,
            type: "link",
            id: this.categories[i].subServices[ij].id,
            catId: this.categories[i].id,
            image: this.categories[i].subServices[ij].ser_image,
          };
          serviceArr.push(childchild);
        }
        this.childrenchildren.push({catId: this.categories[i].id,subservicesArr: serviceArr});
      }

      this.tradmarkschildren = this.allTradmarks.reduce((acc, item) => {
        const catId = item.catId;
        
        if (!acc[catId]) {
          acc[catId] = [];
        }
        
        acc[catId].push(item.tradArr); // only push the tradArr object
        return acc;
      }, {} as { [key: string]: any[] });

      this.subservicechildren = this.childrenchildren.reduce((acc, item) => {
        const catId = item.catId;
        
        if (!acc[catId]) {
          acc[catId] = [];
        }
        
        acc[catId].push(item.subservicesArr); // only push the tradArr object
        return acc;
      }, {} as { [key: string]: any[] });
      
      console.log(this.childrenchildren , 'trasds');
      console.log(this.allTradmarks , 'serve');
      console.log("Menu Items: ", this.menuItems);
      
    }
    
    
  }
  
  

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }


  onHoverIncontainer(){
    this.categoriesContainer.nativeElement.classList.replace('d-none', 'd-block');
    if(this.activeCatId == '')
    {
      this.onHoverIn(this.menuItems[0].id)
    }
  }
  onHoverOutcontainer(){
    this.categoriesContainer.nativeElement.classList.replace('d-block', 'd-none');
  }

  activeCatId: string = '';
  onHoverIn(targetId: string)
  {
    // const activeElements = this.scrollContainer.nativeElement.querySelectorAll('.active');
    // activeElements.forEach((element) => {
    //   element.classList.remove('active');
    // });
    
    this.activeCatId = targetId 
    
    this.currentTadmarksArr = this.tradmarkschildren[this.activeCatId][0];
    
    this.currentSubArr = this.subservicechildren[this.activeCatId][0];
    
    console.log(this.currentTadmarksArr , 'currentTadmarksArr');

    this.cdr.detectChanges();
    if (isPlatformBrowser(this.platformId)) {

      // const container = this.scrollContainer.nativeElement as HTMLElement;

      // const targetElement = container.querySelector(`[data-target="${targetId}"]`) as HTMLElement;

      // if (targetElement) {
      // const offsetTop = targetElement.offsetTop;
      //   container.scrollTo({
      //     top: offsetTop,
      //     behavior: 'smooth'
      //   });     
      //   targetElement.classList.add('active');
      // }
    }
  }
  onHoverOut(targetId: string = '') {
    if (isPlatformBrowser(this.platformId) && targetId == this.activeCatId) {
      // const activeElements = this.scrollContainer.nativeElement.querySelectorAll('.active');
      // activeElements.forEach((element) => {
      //   element.classList.remove('active');
      // });
    }
  }

  changetradmarkesAnsSubServices(catId: string) {
    this.activeCatId = catId;
    this.currentTadmarksArr = this.tradmarkschildren[this.activeCatId][0];
    this.currentSubArr = this.subservicechildren[this.activeCatId][0];
    this.cdr.detectChanges();
  }

  next() {
    if(this.sliderIndex == 0) {
        this.sliderIndex++;
      this.owlCarousel.next(); // Go to next slide
    }
  }

  prev() {
    if(this.sliderIndex == 1) {
      this.sliderIndex--;
      this.owlCarousel.prev();
    
    }// Go to previous slide
  }

  handleImage(e)
  {
    e.target.src = 'assets/images/product/placeholder.jpg';
  }

  goAllout()
  {
    this.activeCatId = '';
  }
}
